import React from 'react';

import { Link } from 'react-router-dom';

export default function InvoicesCell({ row, loan, isBorrower }) {
  if (!row._invoices || row._invoices.length === 0) {
    return '';
  }

  if (row._invoices.length > 1) {
    return (
      <Link
        className="text-blue-600 underline"
        to={`/loans/${loan?.id}/payments/${row.id}?tab=Payment`}
      >
        {row._invoices.length}
      </Link>
    );
  }

  // Render links to invoices as comma separated list
  const pixelNumbers = row._invoices
    .filter((vl) => !!vl)
    .map((vl) => (
      <Link
        className="text-blue-600 underline"
        to={
          isBorrower
            ? `/invoices/${vl.id}`
            : `/loans/${loan?.id}/invoices/${vl.id}?tab=Invoice`
        }
      >
        {vl.pixel_invoice_number}
      </Link>
    ))
    .reduce((prev, curr) => [prev, ', ', curr]);

  return pixelNumbers;
}
